// @flow
import { connect } from 'react-redux';
import _AboutUs from '../components/AboutUs';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
  };
}

export default connect(mapStateToProps)(_AboutUs);



// WEBPACK FOOTER //
// ./src/modules/about-us/containers/AboutUsContainer.js